import { AxiosInstance } from 'axios'
import { createAxiosClientWithAladinBearer } from '@/utils/axios'
import ImportService from './import.service'

export default class SalesStoresService {
  private readonly membershipApiHost: string

  private api: AxiosInstance

  constructor(membershipApiHost: string) {
    this.membershipApiHost = membershipApiHost
    this.api = createAxiosClientWithAladinBearer(`${membershipApiHost}`)
  }

  async import(distributorId, file) {
    return ImportService.import(
      `${this.membershipApiHost}/backoffice/v1/import/cooperatives/${distributorId}/technical-sales/stores`,
      file,
    )
  }

  async downloadSalesStores(distributorId: number, partnerName: string) {
    const response = await this.api.get(`/backoffice/v1/export/partners/${distributorId}/technical-sales/stores`, {
      headers: { accept: 'text/csv' },
    })

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', ImportService.createFileName(partnerName, 'sales-stores'))
    document.body.appendChild(link)
    link.click()
  }
}
